<template>
  <div class="little-dragons-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.name === currentMenu}">
          <!--<a href="#" @click.prevent="currentTab = index">{{ tab.title }}</a>-->
          <router-link :to="{name: tab.name}">
            {{tab.title}}
          </router-link>
        </li>
      </ul>
    </div>
    <router-view class="contents"></router-view>
  </div>
</template>

<script>

export default {
  name: 'TicketSeason',
  data() {
    return {
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {

  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });
    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      if(x.name === 'littleDragons') {
        return x.meta && x.meta.title;
      }
    });
    Object.entries(subMenuList[0].children).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name
      }
      this.tabList.push(result);
    });
  },
  computed: {
    currentMenu() {
      return this.$route.name;
    }
  }
}
</script>
<style scoped lang="scss">
.little-dragons-page {
  .tab-box {
    .tab-btn-list {
      flex-wrap: wrap;
      border-top: 1px solid #ddd;
      border-left: 1px solid #ddd;
      li {
        width: 33.3333%;
        box-sizing: border-box;
        border: none;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
      }
    }
  }
}
</style>